import { baseApiInstanceWithRefresh } from "./baseApiInstance";
import { SLIDE_URL } from "./urls";

const updateSlideConclusion = async (slideId, conclusion) => {
    try {
        const response = await baseApiInstanceWithRefresh.patch(
            `${SLIDE_URL}${slideId}/update-conclusion/`,
            { conclusion: conclusion }
        );
        return response.data;
    } catch (error) {
        console.error('Ошибка при сохранении заключения:', error);
        throw error;
    }
};

export default updateSlideConclusion;